import React, { useState } from "react";
import { Pen } from "../AdminIcons";
import { useGetAllSubCategoriesAdminQuery } from "../../services/categories/categoriesApi";
import Loader from "../common/Loader";
import AddCategoryOptionModal from "./AddCategoryOptionModal";

const SubCategoryTable = () => {
  

  const { data, isLoading, isError, error } =
    useGetAllSubCategoriesAdminQuery();

  const subCategories = data?.data || [];

  const [isEdit, setIsEdit] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const formatDate = (date) => {
    if (!date) return "—";

    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className=" w-full max-w-[1421px] overflow-hidden rounded-lg bg-white shadow-[0_1px_2px_0_#0000000D]">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="border-b border-[#E5E7EB] bg-[#F9FAFB] text-left text-xs font-medium leading-4 text-[#6B7280]">
              <th className="px-7 py-6">Name</th>

              <th className="px-7 py-6">Created By</th>

              <th className="px-7 py-6">Updated By</th>

              <th className="pr-10 py-6 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="4" className="text-center py-8">
                  <Loader />
                </td>
              </tr>
            ) : isError ? (
              <tr>
                <td
                  colSpan="4"
                  className="py-10 text-center text-sm text-red-500"
                >
                  {error?.data?.message || "Failed to load sub categories."}
                </td>
              </tr>
            ) : subCategories.length > 0 ? (
              subCategories.map((sub) => (
                <tr
                  key={sub._id}
                  className="border-b border-[#E5E7EB] transition hover:bg-[#FAFAFA]"
                >
                  <td className="px-7 py-4">
                    <div className="flex items-center gap-3 capitalize">
                      <span className="inline-flex  h-10 w-10 items-center justify-center rounded-lg bg-[#923D8C20] text-sm font-semibold text-[#923D8C]">
                        {sub.title.charAt(0)}
                      </span>

                      <span className=" text-sm font-medium leading-5 text-[#111827]">
                        {sub.title}
                      </span>
                    </div>
                  </td>

                  <td className="px-7 py-4 text-sm  leading-5 text-[#111827]">
                    <div>
                      <p className="font-medium">
                        {sub.createdBy?.firstName} {sub.createdBy?.lastName}
                      </p>

                      <p className="mt-0.5 text-xs font-normal text-[#6B7280]">
                        {sub.createdBy?.email}
                      </p>
                      <p className="mt-1 text-[11px] text-[#9CA3AF]">
                        Created {formatDate(sub.createdAt)}
                      </p>
                    </div>
                  </td>

                  <td className="px-7 py-4 text-sm  leading-5 text-[#111827]">
                    {sub.updatedBy ? (
                      <div>
                        <p className="font-medium">
                          {sub.updatedBy?.firstName} {sub.updatedBy?.lastName}
                        </p>

                        <p className="mt-0.5 text-xs font-normal text-[#6B7280]">
                          {sub.updatedBy?.email}
                        </p>
                        <p className="mt-1 text-[11px] text-[#9CA3AF]">
                          Updated {formatDate(sub.updatedAt)}
                        </p>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 text-[#9CA3AF]">
                        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#F3F4F6]">
                          <span className="text-xs">—</span>
                        </span>
                      </div>
                    )}
                  </td>

                  {/* Actions */}
                  <td className="px-7 py-4">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedSubCategory(sub);
                        setIsEdit(true);
                      }}
                      className="text-[#CA8A04] transition hover:opacity-70"
                    >
                      <Pen color="#CA8A04" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="py-10 text-center text-sm text-gray-400"
                >
                  No sub categories found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isEdit && (
        <AddCategoryOptionModal
           isOpen={isEdit}
          type="subCategory"
          edit={true}
           item={selectedSubCategory}
          onClose={() => {
            setIsEdit(false);
            setSelectedSubCategory(null);
          }}
        />
      )}
    </div>
  );
};

export default SubCategoryTable;
